import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { APP_CONFIG } from 'src/app/config';
import { UserService } from 'src/app/services/user-service/user.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SearchOverlayService } from 'src/app/sidenav/search-overlay/search-overlay.service';

@Component({
  selector: 'app-sidenav-account',
  templateUrl: './sidenav-account.component.html',
  styleUrls: ['./sidenav-account.component.scss']
})
export class SidenavAccountComponent implements OnInit {

  @Input() sidenavMobile: boolean;
  @Input() sidenavOpened: boolean;
  companyData;
  user;
  appConfig;
  getUserInfoSubscription: Subscription;
  getUserInfoSubscriptionRefresh: Subscription;

  constructor(private userStorageService: UserStorageService,
              private router: Router,
              private seekerService: SearchOverlayService,
              private userService: UserService,
              private snackbarService: SnackBarService) {
                this.appConfig = APP_CONFIG;
              }

  ngOnInit() {
    this.companyData = this.userStorageService.getCompanyData();
    this.getUserInfo();
    this.getUserInfoSubscriptionRefresh = this.userService.refreshUserListen().subscribe(
      (res) => {
        this.getUserInfo();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public toggleSeeker() {
    this.seekerService.toggleSeeker();
  }

  public goto(destiny) {
    this.router.navigate([destiny]);
  }

  public getUserInfo() {
    this.getUserInfoSubscription = this.userService.getUserInfo(this.userStorageService.getUserData().InternalId).subscribe(
      (res) => {
          this.user = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public contactUs() {
    location.href = 'mailto: ' + this.appConfig.contactAddress;
  }

  public signOut() {
    this.userService.signOut();
  }

}
